const idMappingCountry = {
  "3l2t2db0c5ow2f7s7bhr6mij4": "Alemania",
  "9l4imoomrnyceg5u3kdxf5l5r": "Arabia Saudí",
  "cbx8lz7loz866tsoawwrpxyl9": "Argelia" ,
  "ak48fkypnql8y4n69cvcq5ghc": "Argentina",
  "bl4fd8cxe6kjvjx8br82gkhnq": "Australia",
  "61g4epojd5f198lv1sje27yh3": "Austria",
  "pfvmhackqyhhk02majd2tb8l" : "Bélgica",
  "o5iztj2zl6b0v6ed9q5m7p1k" : "Bosnia" ,
  "ajab3nmpoltsoeqcuoyi4pwzx": "Brasil" ,
  "1iq69zi4oze3oh0cis0s5wb7o": "Cabo Verde" ,
  "eg7vduna0h3vis1wd47s41za7": "Canadá" ,
  "7km4szeh6fs5bbdgypshh0snd": "Colombia",
  "1yghbv1c71b37eenutbwnvvq" : "Corea" ,
  "39d8zamp9tvg3wc51jxc2a1c0": "C. de Marfil",
  "4njsfszcgd9m765d6suktsz2a": "Croacia",
  "3csexoalt9hfesmo2p4619ga4": "Curazao",
  "2j2402oabiovxw24cnjk9m369": "Ecuador",
  "3669sbeijslw88073qlw1cbcp": "Egipto",
  "bcllqlzvj9j7opjene2zvran7": "Escocia",
  "eh7yt2x2wck51oixw8012ux5j": "España",
  "9vh2u1p4ppm597tjfahst2m3n": "EE.UU.",
  "4pz87gsel7183b7kcadw1dwzv": "Francia",
  "9bix8nlt6cgbson25qntg2zzh": "Ghana",
  "151psmk1h1c846f2lqmflkx75": "Haití",
  "ck8m1cn23sukwsurgx5qakttk": "Inglaterra",
  "cubclbw5k5gdqdau95bnav0nn": "RI de Irán",
  "7u6a9femhquay3jnk6ysgiwx9": "Irak" ,
  "6duaxcbrofil112qfq4v895go": "Japón",
  "btn8ibf55ovz7y252vdiprbip": "Jordania",
  "avggs3u2b5cu8i1dnzknhth52": "Marruecos",
  "4vofb84dzb5fyc81n2ssws6ah": "México",
  "e1vf7kzswllumuykwezkrbo70": "Noruega",
  "bhu61cgwm07e2pik1jqmnztgl": "Nueva Zelanda" ,
  "657oha8nkne1ybba2bouzkbo7": "Paises Bajos" ,
  "8856r86rattc8kxn6a0l9tb2t": "Panamá" ,
  "3cwjdmekfdouwg990mqdq9fh0": "Paraguay" ,
  "8gxg8f7p9299jbrz30u8bsc7g": "Portugal" ,
  "ea68amhsn28ijs7bzjuzeqrz6": "Qatar" ,
  "70tnqyqn871jwlk26gtjw7knm": "República Checa" ,
  "dd4ko7d3muqheb54u1s9k39p3": "RD Congo",
  "2wk1549tkz80oet8226euj7jp": "Senegal",
  "xmip8t9f2kefltjkraxzsxl9" : "Sudáfrica",
  "4w1ktgu1nbbgqfe3ssbb4fg5v": "Suecia",
  "339wxbt07ltnva7hop6m5o477": "Suiza" ,
  "ctp7ovvf34m7fzshua9ogbr6i": "Túnez" ,
  "9s2kpeunkes0g17l95r3t91j6": "Turquía",
  "9l06impjllgop0gte8fldb4zo": "Uruguay",
  "elayenut7wtobtmg7hyujzdoe": "Uzbekistán"
};

// Ahora idMappingCountry ya tiene el formato: ID -> País
// No necesitamos crear un reverso, lo usamos directamente

/**
 * Convierte un ID de país a su nombre equivalente
 * @param {string} countryId - El ID del país a convertir
 * @returns {string} - El nombre del país o el ID original si no está en el mapeo
 */
export const getCountryFromId = (countryId) => {
  return idMappingCountry[countryId] || countryId;
};

/**
 * Convierte un nombre de país a su ID
 * @param {string} countryName - El nombre del país a convertir
 * @returns {string} - El ID del país o el nombre original si no está en el mapeo
 */
export const getIdFromCountry = (countryName) => {
  // Buscar el país en el mapeo
  for (const [id, country] of Object.entries(idMappingCountry)) {
    if (country === countryName) {
      return id;
    }
  }
  return countryName;
};

/**
 * Reemplaza todos los IDs de países en un objeto por sus nombres equivalentes
 * Busca específicamente en el campo "id" de objetos dentro de arrays
 * @param {object} data - El objeto a procesar (tipicamente OFFICIAL_GROUP_STANDINGS)
 * @returns {object} - El objeto con IDs de países reemplazados por nombres
 */
export const replaceCountryIds = (data) => {
  if (typeof data !== 'object' || data === null) {
    return data;
  }

  if (Array.isArray(data)) {
    return data.map(item => {
      if (typeof item === 'object' && item !== null) {
        // Procesar cada propiedad del item
        const processedItem = {};
        for (const [key, value] of Object.entries(item)) {
          if (key === 'id') {
            // Si es el campo "id", reemplazar el ID del país por su nombre
            processedItem[key] = idMappingCountry[value] || value;
          } else if (typeof value === 'object' && value !== null) {
            // Si es un objeto/array, procesarlo recursivamente
            processedItem[key] = replaceCountryIds(value);
          } else {
            // Mantener el valor tal cual
            processedItem[key] = value;
          }
        }
        return processedItem;
      }
      return item;
    });
  }

  // Para objetos (no arrays), procesar recursivamente
  const result = {};
  for (const [key, value] of Object.entries(data)) {
    if (Array.isArray(value)) {
      // Si es un array, procesarlo
      result[key] = replaceCountryIds(value);
    } else if (typeof value === 'object' && value !== null) {
      // Si es un objeto, procesarlo recursivamente
      result[key] = replaceCountryIds(value);
    } else {
      // Mantener el valor tal cual
      result[key] = value;
    }
  }

  return result;
};

export default {
  idMappingCountry,
  getCountryFromId,
  getIdFromCountry,
  replaceCountryIds
};